import { render, staticRenderFns } from "./FactoringCreate.vue?vue&type=template&id=72219277&scoped=true"
import script from "./FactoringCreate.vue?vue&type=script&lang=js"
export * from "./FactoringCreate.vue?vue&type=script&lang=js"
import style0 from "./FactoringCreate.vue?vue&type=style&index=0&id=72219277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72219277",
  null
  
)

export default component.exports